import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import DemoOrderPage from './components/DemoOrderPage';
import './App.css';

// 데모(/start) 전용 앱 - 메인 서비스(woworder/build)와 완전히 분리된 별도 빌드
// REACT_APP_BUILD_TARGET=demo 로 빌드 시 index.js가 이 컴포넌트를 렌더
function DemoApp() {
  return (
    <Router basename="/start">
      <div className="App">
        <Routes>
          <Route path="/" element={<DemoOrderPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default DemoApp;
